import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  id: string;
  imageType: string;
}

interface Result {
  url: string;
  headers: Record<string, string>;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/organisations/avatar-upload-url',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useGetOrganisationUploadUrl = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useGetOrganisationUploadUrlLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useGetOrganisationUploadUrl;
